import { Button, Center, Paper, Stack, Text, Title } from '@mantine/core';
import { signInWithGoogle, signOutEverywhere } from '../lib/supabase';

export function Login() {
  return (
    <Center h="100vh">
      <Paper withBorder p="xl" radius="md" w={360}>
        <Stack>
          <Title order={3}>Ascera Admin</Title>
          <Text size="sm" c="dimmed">
            Sign in with your ascera.life account.
          </Text>
          <Button onClick={() => void signInWithGoogle()}>Continue with Google</Button>
        </Stack>
      </Paper>
    </Center>
  );
}

export function NoAccess({ email }: { email: string }) {
  return (
    <Center h="100vh">
      <Paper withBorder p="xl" radius="md" w={420}>
        <Stack>
          <Title order={4}>This account doesn&apos;t have admin access</Title>
          <Text size="sm" c="dimmed">
            You&apos;re signed in as {email}. Admin access is granted per account — ask an existing
            admin to add you, following docs/runbooks/admin-access.md.
          </Text>
          <Button
            variant="light"
            title="Also signs you out of the ops MCP and the mobile app on this account."
            onClick={() => void signOutEverywhere()}
          >
            Sign out everywhere
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
